export default __webpack_public_path__ + "static/media/img_star.ccc49cab.svg";